const educationAr = [
  {
    degree: "بكالوريوس في تصميم وهندسة أنظمة المعلومات (CSI)",
    institution: "مدرسة المهندسين 3iL (ليموج، فرنسا) • المستوى السادس RNCP (بكالوريوس Bac+3)",
    period: "نوفمبر 2019 - ديسمبر 2021",
    description: "شهادة فرنسية معتمدة من فرنسا للمهارات (France Compétences) والمستوى السادس في السجل الوطني للشهادات المهنية (RNCP)، نُفذت عبر الشراكة الأكاديمية الدولية الرسمية مع معهد ETM ابن رشد. ركز البرنامج على تحليل وتصميم أنظمة المعلومات المؤسسية (Merise، UML)، هندسة قواعد البيانات العلائقية (Oracle، SQL)، شبكات سيسكو والتوجيه، إدارة أنظمة لينكس، وإدارة دورة حياة المشاريع البرمجية.",
    skills: [
      "معمارية أنظمة المعلومات",
      "قواعد بيانات Oracle و SQL",
      "شبكات سيسكو والتوجيه Routing",
      "إدارة أنظمة لينكس Linux",
      "دورة حياة هندسة البرمجيات",
      "إدارة المشاريع التقنية"
    ],
  },
  {
    degree: "دبلوم مهندس محترف في الإعلام الآلي — تصميم أنظمة المعلومات",
    institution: "معهد ETM ابن رشد (بالشراكة مع مدرسة 3iL Ingénieurs بفرنسا)",
    period: "نوفمبر 2019 - ديسمبر 2021",
    description: "منهج هندسي مزدوج لنيل الشهادة بالشراكة مع مدرسة المهندسين الفرنسية 3iL. تمحورت الدراسة حول نمذجة البرمجيات المؤسسية، المعماريات الموزعة، إدارة قواعد البيانات، أمن البنية التحتية والشبكات، وترجمة متطلبات الأعمال المعقدة إلى أنظمة معلوماتية متينة وقابلة للتوسع.",
    skills: [
      "علوم الحاسوب والبرمجيات",
      "تصميم قواعد البيانات العلائقية",
      "نمذجة وتحليل الأنظمة المؤسسية",
      "البنية التحتية للشبكات والأمان",
      "حوكمة وإدارة البيانات"
    ],
  },
  {
    degree: "شهادة مهنية في التطوير الشامل لتطبيقات الويب (Full-Stack)",
    institution: "مدرسة الاتصال والإعلام الآلي (ECI)",
    period: "2017 - 2018",
    description: "برنامج تدريبي مهني مكثف مخصص لهندسة الويب الحديثة ومعمارية التطبيقات التفاعلية الديناميكية. شمل دراسة نماذج الخادم والعميل (Client-Server)، تصميم واجهات برمجة التطبيقات RESTful، ربط وإدارة قواعد البيانات، وبناء تطبيقات ويب متكاملة وجاهزة للإنتاج باستخدام أحدث أطر عمل JavaScript و PHP.",
    skills: [
      "تطوير الويب الشامل Full-Stack",
      "تصميم واجهات RESTful APIs",
      "معمارية الخادم والعميل",
      "لغات JavaScript و PHP الحديثة",
      "تصميم واجهات الويب المتجاوبة"
    ],
  },
  {
    degree: "دراسات جامعية في الفيزياء والعلوم التطبيقية",
    institution: "جامعة الجزائر (كلية العلوم)",
    period: "2015 - 2017",
    description: "تكوين جامعي تأسيسي في الفيزياء الأساسية، التفاضل والتكامل، الديناميكا الحرارية، والتحليل الرياضي. ساهم في ترسيخ مهارات التحليل المنطقي من المبادئ الأولى، والنمذجة الرياضية، وحل المشكلات الهندسية الكمية المعقدة بصرامة علمية.",
    skills: [
      "التفكير والتحليل من المبادئ الأولى",
      "التحليل الرياضي والتفاضل والتكامل",
      "الفيزياء التطبيقية",
      "النمذجة الرياضية والتحليلية"
    ],
  },
  {
    degree: "شهادة تقني سامٍ (TS) — شبكات وأنظمة الاتصالات",
    institution: "المعهد الوطني المتخصص في التكوين المهني (INSFP - المحمدية)",
    period: "2014 - 2017",
    description: "شهادة تقني سامٍ تمنحها الدولة، تشمل التكوين التطبيقي في هندسة أنظمة الحواسيب، إدارة شبكات الاتصال، بروتوكولات الاتصالات السلكية واللاسلكية، تشخيص وصيانة العتاد الصلب، وبنية التوجيه عبر شبكات TCP/IP.",
    skills: [
      "إدارة شبكات الحاسوب (TCP/IP)",
      "تشخيص العتاد وصيانة الأنظمة",
      "بروتوكولات الاتصالات",
      "صيانة وإدارة الخوادم",
      "أنظمة التشغيل المؤسسية"
    ],
  },
];

export default educationAr;
